import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";

export class PictureDTO{
    id: number;
    name: string = ''
    mimeType: string = ''
    userId: number;
    fileDownloadUri: string = ''

    constructor(data: Partial<PictureDTO> = {}){
        for(let key in data){
            if(key === 'fileDowloadUri' || key === 'fileDownloadUri'){
                this.fileDownloadUri = (data as any)?.fileDowloadUri ?? data.fileDownloadUri;
                this.fileDownloadUri = getFilePathWithBackendUrl(this.fileDownloadUri);
            }else if(key === 'name'){
                this[key] = getFilePathWithBackendUrl(data[key]);
                // If fileDownloadUri is not provided, use name as fileDownloadUri
                if(!this.fileDownloadUri && data[key]){
                    this.fileDownloadUri = getFilePathWithBackendUrl(data[key]);
                }
            }else{
                this[key] = data[key];
            }
        }
    }
}